import React from 'react';
import Button from '../../../components/ui/Button';

const NavigationControls = ({ 
  currentSection, 
  totalSections, 
  onPrevious, 
  onNext 
}) => {
  const isFirstSection = currentSection === 0;
  const isLastSection = currentSection === totalSections - 1;

  return (
    <div className="flex items-center justify-between py-6 border-t border-border">
      <Button
        variant="outline"
        iconName="ChevronLeft"
        iconPosition="left"
        onClick={onPrevious}
        disabled={isFirstSection}
      >
        Previous Section
      </Button>
      
      <div className="text-sm text-muted-foreground">
        Section {currentSection + 1} of {totalSections}
      </div>
      
      <Button
        variant="outline"
        iconName="ChevronRight"
        iconPosition="right"
        onClick={onNext}
        disabled={isLastSection}
      >
        Next Section
      </Button>
    </div>
  );
};

export default NavigationControls;